import * as types from "./actionTypes";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {getBvFeatures} from "../api/server-api";
import {IS_QKB_UI} from "../config";
import {
  changeWizardValuesToUseNewGroups,
  getConflictingWizardSteps, getNextWizardSteps,
  getWizardVisualizerType, isSameVisualizerWizard, switchCartItemsToNewWizardGroups
} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {getUpdatedAllWizardValues} from "../reducers/wizardReducer";
import {changeAllCartItems} from "./shoppingCartFunctions";
import {navItemIsExcluded} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

export const setWizardIsActive = (wizardIsActive, visualizerType) => ({
  type: types.SET_WIZARD_IS_ACTIVE,
  payload: {wizardIsActive, visualizerType}
});

export const setWizardConfig = (wizardConfig) => ({
  type: types.SET_WIZARD_CONFIG,
  payload: {wizardConfig}
});

export const setWizardList = (wizardList) => ({
  type: types.SET_WIZARD_LIST,
  payload: {wizardList}
});

export const setWizardActiveItem = (wizardActiveItem, quoteIndex = null) => {
  return (dispatch, getState) => {
    const {quotesState} = getState();

    dispatch({
      type: types.SET_WIZARD_ACTIVE_ITEM,
      payload: {
        wizardActiveItem,
        quoteIndex: Number.isInteger(quoteIndex) ? quoteIndex : quotesState.activeQuoteIndex,
      }
    })
  }
};

export const setWizardShowFeatureSection = (wizardShowFeatureSection) => ({
  type: types.SET_WIZARD_SHOW_FEATURE_SECTION,
  payload: {wizardShowFeatureSection}
});

export const setWizardActiveStep = (wizardActiveStep,
                                    currentWizardItem = null,
                                    currentQuoteIndex = null,
                                    forceEraseAllWizardValues = false,
) => {
  return (dispatch, getState) => {
    const {quotesState, wizardState} = getState();

    const quoteIndex = Number.isInteger(currentQuoteIndex) ? currentQuoteIndex : quotesState.activeQuoteIndex;
    const wizardItem = currentWizardItem || wizardState.wizardActiveItem;

    let wizardConflictingSteps = wizardState.wizardConflictingSteps;
    let newWizValues = Object.assign({}, wizardState.wizardSelectedValues);
    if (!IS_QKB_UI || forceEraseAllWizardValues) {
      Object.keys(wizardState.wizardSelectedValues).reverse().forEach(selectedKeyNumber => { // erase conflicting selected steps!
        if (selectedKeyNumber > wizardActiveStep) {
          delete newWizValues[selectedKeyNumber]
        }
      });
    }
    if (wizardState.wizardConflictingSteps.length) {
      wizardConflictingSteps = [];
    }
    let allWizardsValues = wizardState.allWizardsValues;
    if (wizardItem) {
      allWizardsValues = wizardState.allWizardsValues.map(wizObject => {
        if (wizObject.wizardItemId === wizardItem.id && wizObject.quoteIndex === quoteIndex
          && isSameVisualizerWizard(wizObject)) {
          wizObject.lastVisitedStep = wizardActiveStep // keep it up to date to be able to restore
          if (wizardState.wizardConflictingSteps.length || forceEraseAllWizardValues) {
            wizObject.wizardSelectedValues = Object.assign({}, newWizValues)
          }
        }
        return wizObject
      })
    }

    dispatch({
      type: types.SET_WIZARD_ACTIVE_STEP,
      payload: {
        wizardActiveStep,
        wizardSelectedValues: newWizValues,
        wizardConflictingSteps,
        allWizardsValues,
        quoteIndex,
      }
    })
  }
}

export const clearWizardSelectedValue = (neededStep, currentWizardItem = null, currentQuoteIndex = null) => {
  return (dispatch, getState) => {
    const {quotesState, wizardState} = getState();

    const quoteIndex = Number.isInteger(currentQuoteIndex) ? currentQuoteIndex : quotesState.activeQuoteIndex;
    const wizardItem = currentWizardItem || wizardState.wizardActiveItem;

    let newWizValues = Object.assign({}, wizardState.wizardSelectedValues);
    Object.keys(wizardState.wizardSelectedValues).forEach(selectedKeyNumber => { // erase conflicting selected steps!
      if (+selectedKeyNumber === +neededStep) {
        delete newWizValues[selectedKeyNumber]
      }
    });
    let allWizardsValues = wizardState.allWizardsValues;
    if (wizardItem) {
      allWizardsValues = wizardState.allWizardsValues.map(wizObject => {
        if (wizObject.wizardItemId === wizardItem.id && wizObject.quoteIndex === quoteIndex
          && isSameVisualizerWizard(wizObject)) {
          if (wizardState.wizardConflictingSteps.length) {
            wizObject.wizardSelectedValues = Object.assign({}, newWizValues)
          }
        }
        return wizObject
      })
    }

    dispatch({
      type: types.SET_WIZARD_SELECTED_VALUES,
      payload: {
        wizardSelectedValues: newWizValues,
        allWizardsValues,
        quoteIndex,
        wizardConflictingSteps: wizardState.wizardConflictingSteps
      }
    })
  }
}

export const setWizardSelectedValues = (wizardSelectedValues, direct = false, wizardItem = null, currentQuoteIndex = null) => {
  return (dispatch, getState) => {
    const {quotesState, wizardState, cartState, fabricatorState} = getState();
    const {cartItems} = cartState;
    const wizardActiveItem = wizardItem || wizardState.wizardActiveItem;
    const quoteIndex = Number.isInteger(currentQuoteIndex) ? currentQuoteIndex : quotesState.activeQuoteIndex;

    let wizardConflictingSteps = wizardState.wizardConflictingSteps;

    if (!direct && Object.keys(wizardSelectedValues).length === 1) {
      const currentStep = Object.keys(wizardSelectedValues)[0];
      if (currentStep) {
        const wizardGroup = wizardSelectedValues[currentStep].wizardGroup;
        const selectedFeature = wizardSelectedValues[currentStep].selectedFeature;
        if (wizardGroup && wizardGroup.mergedGroups && selectedFeature) {
          const realWizardGroup = wizardGroup.mergedGroups.find(wizG => !navItemIsExcluded({part: selectedFeature}, wizG));
          if (realWizardGroup) {
            if ((realWizardGroup.id !== wizardSelectedValues[currentStep].wizardGroup.id)) {
              wizardSelectedValues[currentStep].wizardGroup = Object.assign({}, wizardGroup, {
                id: realWizardGroup.id
              });
              // console.log("accurateWizardGroup!", wizardSelectedValues[currentStep].wizardGroup);
            }
          } else {
            console.log("how is that possible? wizardGroup.mergedGroups", wizardGroup.mergedGroups, selectedFeature);
          }
        }
      }
    }

    let newWizValues = direct
      ? Object.assign({}, wizardSelectedValues)
      : Object.assign({}, wizardState.wizardSelectedValues, wizardSelectedValues);

    // console.log("newWizValues", newWizValues);

    if (IS_QKB_UI && fabricatorState.settings.checkout && cartItems.length && !direct
      && wizardSelectedValues && Object.keys(wizardSelectedValues).length === 1) {

      const currentStep = +Object.keys(wizardSelectedValues)[0];
      const commonObject = {wizardActiveItem, quoteIndex, wizardSelectedValues};
      let newWizardSteps = getNextWizardSteps(wizardActiveItem, currentStep, newWizValues);

      // console.log("newWizardSteps", newWizardSteps);
      // here we replace cartItems to match new selections! to prevent conflicting
      let {updatedWizardValues, shouldReassignValues} = changeWizardValuesToUseNewGroups(newWizValues, newWizardSteps);
      if (shouldReassignValues) {
        newWizValues = updatedWizardValues;
        // create new steps according to new values
        newWizardSteps = getNextWizardSteps(wizardActiveItem, currentStep, newWizValues);
        // console.log("newWizardSteps2!", newWizardSteps);
      }
      // here we replace cartItems to match new selections! to prevent conflicting
      let {newCartItems, shouldReassign} = switchCartItemsToNewWizardGroups(
        newWizardSteps,
        commonObject,
        cartItems,
      );
      if (shouldReassign) {
        dispatch(changeAllCartItems([...newCartItems]))
      }

      wizardConflictingSteps = getConflictingWizardSteps(
        newWizValues,
        commonObject,
        newCartItems,
        newWizardSteps,
      );
    }

    if (wizardActiveItem) {
      // console.log("wizardConflictingSteps", action.payload.wizardConflictingSteps);
      // this works for QKB UI only for now, we are not using it on lixil
      const allWizardsValues = wizardConflictingSteps.length // do not change them to be able to restore when wizard is closed
        ? wizardState.allWizardsValues
        : getUpdatedAllWizardValues(wizardState, quoteIndex, wizardActiveItem.id, newWizValues);

      dispatch({
        type: types.SET_WIZARD_SELECTED_VALUES,
        payload: {
          quoteIndex,
          wizardSelectedValues: newWizValues,
          allWizardsValues,
          wizardConflictingSteps
        }
      });

      return;
    }

    dispatch({
      type: types.SET_WIZARD_SELECTED_VALUES,
      payload: {
        wizardSelectedValues: newWizValues,
        wizardConflictingSteps,
        // direct,
        quoteIndex,
        // wizardActiveItem: wizardItem || wizardState.wizardActiveItem,
        // fabricatorState,
        // cartItems: cartState.cartItems
      }
    })
  }
}

export const setAllWizardSelectedValues = (wizardSelectedValues, quoteIndex, wizardItemId) => ({
  type: types.SET_ALL_WIZARD_SELECTED_VALUES,
  payload: {wizardSelectedValues, quoteIndex, wizardItemId}
});

const getMissingWizardValuesFeatures = async (compressedAllWizardsValues) => {

  const missingFeatures = {};

  // 1) find missing features;
  compressedAllWizardsValues.forEach(wizardObject => {

    const visualizerType = getWizardVisualizerType(wizardObject, true);
    const layout = getCurrentLayout(visualizerType);

    if (!missingFeatures[visualizerType]) {
      missingFeatures[visualizerType] = [];
    }

    Object.keys(wizardObject.wizardSelectedValues).forEach(stepIndex => {
      const compressedFeature = wizardObject.wizardSelectedValues[stepIndex].selectedFeature;
      if (compressedFeature) {
        const featureGroup = layout.getFeatureGroupByPartId(compressedFeature.partId);
        if (!featureGroup && !missingFeatures[visualizerType].includes(compressedFeature.dbFeatureId)) {
          missingFeatures[visualizerType].push(compressedFeature.dbFeatureId);
          return
        }
        const loadedFeature = layout.getLoadedFeatureById(compressedFeature.dbFeatureId, featureGroup);
        if (!loadedFeature && !missingFeatures[visualizerType].includes(compressedFeature.dbFeatureId)) {
          missingFeatures[visualizerType].push(compressedFeature.dbFeatureId);
        }
      }
    });
  })

  // 2) get missing features from the backend;
  for (let visualizerType of Object.keys(missingFeatures)) {
    if (missingFeatures[visualizerType].length) {
      // loaderEnable();
      const featuresFromJob = await getBvFeatures(missingFeatures[visualizerType]);
      if (featuresFromJob && featuresFromJob.data) {
        // console.log("featuresFromJob", featuresFromJob.data);
        const layout = getCurrentLayout(visualizerType);
        layout.loadNewFeatures(featuresFromJob.data);
      }
      // loaderDisable();
    }
  }
  return Promise.resolve()
}
const getRestoredWizardValues = (compressedAllWizardsValues, wizardList) => {

  // 3) now we can set the values
  let allWizardsValues = [];
  compressedAllWizardsValues.forEach(wizardObject => {
    let wizardValues = {};
    const wizardItem = wizardList.find(wizItem => wizItem.id === wizardObject.wizardItemId);
    if (!wizardItem) {
      console.log("hmmm, it looks like the wizard was deleted, but it was active in the job", wizardObject);
      return
    }

    const visualizerType = getWizardVisualizerType(wizardObject, true);
    const layout = getCurrentLayout(visualizerType);

    Object.keys(wizardObject.wizardSelectedValues).forEach(stepIndex => {

      const selectedWizardObject = Object.assign({}, wizardObject.wizardSelectedValues[stepIndex]);

      //3.1) copy all other values
      wizardValues[stepIndex] = selectedWizardObject.wizardGroup ? Object.assign({}, selectedWizardObject, {
        wizardGroup: Object.assign({}, selectedWizardObject.wizardGroup, {
          mergedGroups: selectedWizardObject.wizardGroup.mergedGroups ? [] : null
        })
      }) : Object.assign({}, selectedWizardObject)

      //3.2) update wizardGroup with all excluded features
      if (selectedWizardObject.wizardGroup) {
        const realWizardGroup = wizardItem.wizardGroups.find(wizGroup => wizGroup.id === selectedWizardObject.wizardGroup.id);
        if (realWizardGroup) {
          wizardValues[stepIndex].wizardGroup = realWizardGroup;
        } else {
          console.log("wizard was changed, wizard group not found", selectedWizardObject.wizardGroup);
          wizardValues[stepIndex] = {};
        }
        if (selectedWizardObject.wizardGroup.mergedGroups && realWizardGroup) {
          selectedWizardObject.wizardGroup.mergedGroups.forEach(compressedWG => {
            const foundWg = wizardItem.wizardGroups.find(wizGroup => {
              return wizGroup.id === compressedWG.id && wizGroup.groupName === compressedWG.groupName
            });
            if (foundWg) {
              if (!wizardValues[stepIndex].wizardGroup.mergedGroups) {
                wizardValues[stepIndex].wizardGroup.mergedGroups = [];
              }
              wizardValues[stepIndex].wizardGroup.mergedGroups.push(Object.assign({}, foundWg, {mergedGroups: null})); // to prevent circular
            } else {
              console.log("WIZARD WAS CHANGED, merged wizard group can't be found!", );
            }
          })
        }
      }

      //3.3) update selectedFeature
      if (selectedWizardObject.selectedFeature) {
        const featureGroup = layout.getFeatureGroupByPartId(selectedWizardObject.selectedFeature.partId);
        wizardValues[stepIndex].selectedFeature = featureGroup
          ? layout.getLoadedFeatureById(selectedWizardObject.selectedFeature.dbFeatureId, featureGroup)
          : null;
      }
    });
    allWizardsValues.push(Object.assign({}, wizardObject, {wizardSelectedValues: wizardValues}));
  })
  console.log("restoring allWizardsValues:", allWizardsValues);
  return allWizardsValues
}

export const updateAllWizardValues = (allWizardsValues) => ({
  type: types.RESTORE_ALL_WIZARD_SELECTED_VALUES,
  payload: {allWizardsValues}
})

export const restoreAllWizardSelectedValues = (compressedAllWizardsValues) => {
  return async (dispatch, getState) => {
    const {wizardState} = getState();
    await getMissingWizardValuesFeatures(compressedAllWizardsValues);
    const valuesToRestore = getRestoredWizardValues(compressedAllWizardsValues, wizardState.wizardList);
    dispatch(updateAllWizardValues(valuesToRestore));
  }
}

export const setWizardMissingFeatures = (groupName = "", wizardMissingFeatures = []) => ({
  type: types.SET_WIZARD_MISSING_FEATURES,
  payload: {
    groupName,
    wizardMissingFeatures
  }
});

export const setWizardConflictPopupOpened = (wizardConflictPopupOpened) => ({
  type: types.SET_WIZARD_CONFLICT_POPUP_OPENED,
  payload: {wizardConflictPopupOpened}
});

export const setWizardConflictSteps = (wizardConflictingSteps) => ({
  type: types.SET_WIZARD_CONFLICT_STEPS,
  payload: {wizardConflictingSteps}
});

export const setWizardSqftCartItems = (wizardSqftCartItems) => ({
  type: types.SET_WIZARD_SQFT_CART_ITEMS,
  payload: {wizardSqftCartItems}
});

export const setWizardAllowSkipDoneSteps = (wizardAllowSkipDoneSteps) => ({
  type: types.SET_WIZARD_ALLOW_SKIP_DONE_STEPS,
  payload: {wizardAllowSkipDoneSteps}
});
